import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Portfoliosdetailstopsection from "../components/Portfoliosdetailstopsection";
import Overviewsection from "../components/overviewsection";
import Technologysection from "../components/Technologysection";
import WebsiteFeaturesBanner from "../components/WebsiteFeaturesBanner";
import ContactForm from "../components/contact-form";
import okbajuLogo from "../images/okbaju-logo.png";
import storiseLogo from "../images/storise-logo.png";
import okbajuAppImg from "../images/comp/okbaju-app.webp";
import storiseAppImg from "../images/comp/storise-app.webp";

const AppPortfoliosdetailsPage = () => {
  const { id } = useParams();

  // All app portfolio details data
  const allAppPortfoliosData = {
    "okbaju-app": {
      portfolioData: {
        logoimage: okbajuLogo,
        title: "Home services at your doorstep with the OkBaju App.",
        description:
          "Experience OkBaju on the go with our mobile application. Seamlessly browse fashion collections, make purchases, and manage your profile from anywhere. The mobile app brings the full OkBaju shopping experience to your fingertips.",
        buttontext: "Get a Quote",
        buttonlink: "/contact",
        image: okbajuAppImg,
      },
      overviewData: {
        image: okbajuAppImg,
        title: "OkBaju Mobile App – Project Overview",
        description: `The OkBaju mobile application delivers a premium shopping experience optimized for iOS and Android devices. Built with modern mobile development frameworks, the app provides smooth navigation, fast loading times, and intuitive user interfaces. Features include push notifications for new arrivals, personalized recommendations, easy checkout, and secure payment processing. The app ensures a seamless experience whether users are browsing, comparing products, or completing purchases.`,
        buttontext: "Get a Quote",
        buttonlink: "/contact",
      },
      technologyData: {
        mainTitle: "Technology Stack",
        subTitle:
          "The OkBaju mobile app is built using cutting-edge mobile development technologies to ensure optimal performance and user experience across all devices.",
        categories: [
          {
            title: "Frontend",
            items: [
              {
                label: "React Native",
                text: "Cross-platform mobile framework for building native iOS and Android apps with a single codebase.",
              },
              {
                label: "JavaScript, TypeScript",
                text: "Modern programming languages for developing responsive and type-safe mobile interfaces.",
              },
            ],
          },
          {
            title: "Backend",
            items: [
              {
                label: "RESTful APIs",
                text: "RESTful API integration for seamless data synchronization with the web platform.",
              },
              {
                label: "Node.js",
                text: "Backend services for handling mobile app requests and data processing.",
              },
            ],
          },
          {
            title: "Features",
            items: [
              {
                label: "Push Notifications",
                text: "Real-time notifications for order updates, promotions, and personalized alerts.",
              },
              {
                label: "Offline Mode",
                text: "Local data caching for browsing products even without internet connectivity.",
              },
            ],
          },
          {
            title: "UI/UX Design",
            items: [
              {
                label: "Figma, Adobe XD",
                text: "Professional design tools for creating intuitive mobile interfaces and user flows.",
              },
            ],
          },
        ],
      },
      WebsiteFeaturesData: {
        title: "OkBaju Mobile App – Features",
        description:
          "OkBaju is a single-vendor fashion e-commerce platform built to make online shopping easy, fast, and enjoyable. The website allows users to browse a curated catalog of clothing, view detailed product pages, and quickly add items to their cart. With features like secure login, personalized profiles, and a smooth checkout process, OkBaju ensures a seamless and user-friendly shopping experience.",
        image: okbajuAppImg,
        imageAlt: "OkBaju Mobile App Features",
        websiteFeaturesTitle: "App Features",
        websiteFeatures: [
          "Easy Product Browsing: Browse a curated catalog of clothing, view detailed product pages, and quickly add items to your cart.",
          "Quick Add to Cart: Add items to your cart quickly and easily.",
          "Secure Mobile Payments: Pay securely and conveniently with your preferred payment method.",
          "Order Tracking: Track your orders and get updates on their status.",
          "Wishlist Management: Save your favorite items for later.",
          "Push Notifications: Get updates on new arrivals, promotions, and more.",
        ],
        adminPanelTitle: "Admin Panel Features",
        adminFeatures: [
          "App Analytics Dashboard: View real-time analytics and insights to optimize your app performance.",
          "User Engagement Metrics: Track user engagement and behavior to improve the app experience.",
          "Push Notification Management: Send updates, promotions, and important alerts to users instantly.",
          "In-App Content Updates: Easily update the app content and features to keep users engaged.",
          "User Support System: Provide a seamless support system for users to get help and resolve issues.",
        ],
      },
    },
    "storise-app": {
      portfolioData: {
        logoimage: storiseLogo,
        title: "Storise Mobile App",
        description:
          "Listen to your favorite stories, audiobooks, and podcasts anywhere with the Storise mobile app. Enjoy seamless streaming, offline downloads, and personalized recommendations tailored to your listening preferences.",
        buttontext: "Get a Quote",
        buttonlink: "/contact",
        image: storiseAppImg,
      },
      overviewData: {
        image: storiseAppImg,
        title: "Storise Mobile App – Project Overview",
        description: `The Storise mobile application brings the entire audio streaming experience to iOS and Android devices. Users can discover new content, create playlists, download for offline listening, and enjoy personalized recommendations. The app features smooth playback controls, background audio support, and intuitive navigation. Built with performance in mind, it delivers high-quality audio streaming while minimizing data usage and battery consumption.`,
        buttontext: "Get a Quote",
        buttonlink: "/contact",
      },
      technologyData: {
        mainTitle: "Technology Stack",
        subTitle:
          "The Storise mobile app leverages modern mobile technologies to deliver a seamless audio streaming experience with excellent performance and reliability.",
        categories: [
          {
            title: "Frontend",
            items: [
              {
                label: "React Native",
                text: "Cross-platform framework for building native mobile apps with shared codebase.",
              },
              {
                label: "React Native Audio",
                text: "Specialized libraries for audio playback, streaming, and background audio support.",
              },
            ],
          },
          {
            title: "Backend",
            items: [
              {
                label: "RESTful APIs",
                text: "API integration for content streaming, user authentication, and playlist management.",
              },
              {
                label: "Cloud Storage",
                text: "Efficient audio file storage and CDN integration for fast content delivery.",
              },
            ],
          },
          {
            title: "Features",
            items: [
              {
                label: "Offline Downloads",
                text: "Download audio content for offline listening with intelligent storage management.",
              },
              {
                label: "Background Playback",
                text: "Continue listening while using other apps with background audio support.",
              },
            ],
          },
          {
            title: "UI/UX Design",
            items: [
              {
                label: "Figma",
                text: "Modern design tools for creating intuitive mobile interfaces optimized for audio content.",
              },
            ],
          },
        ],
      },
      WebsiteFeaturesData: {
        title: "Storise Mobile App – Features",
        description:
          "The Storise mobile app provides a rich set of features to enhance your audio listening experience on mobile devices.",
        image: storiseAppImg,
        imageAlt: "Storise Mobile App Features",
        websiteFeaturesTitle: "App Features",
        websiteFeatures: [
          "Browse Full Fashion Collection: Explore trending outfits, accessories, and seasonal styles.",
          "Profile & Account Management: Update personal details, addresses, and preferences easily.",
          "Multi-language Support: Enjoy the interface in your preferred language.",
          "In-App Offers & Coupons: Exclusive deals available only on the app.",
          "Easy Returns & Support: Initiate returns and connect with customer support instantly.",
          "Fast Performance: Optimized for smooth and lag-free experience.",
        ],
        adminPanelTitle: "Admin Panel Features",
        adminFeatures: [
          "Dashboard Overview: Real-time insights on sales, orders, users, and traffic.",
          "Product Management: Add, edit, update, or remove products with ease.",
          "Inventory Control: Manage stock levels and get low-stock alerts.",
          "Subscription Management: Manage user subscriptions and billing.",
          "Push Notifications: Send updates, promotions, and important alerts to users instantly.",
        ],
      },
    },
  };

  // Get current portfolio data based on ID, default to okbaju-app if not found
  const currentPortfolio =
    allAppPortfoliosData[id] || allAppPortfoliosData["okbaju-app"];

  const { portfolioData, overviewData, technologyData, WebsiteFeaturesData } =
    currentPortfolio;

  return (
    <div>
      <Header />

      <Portfoliosdetailstopsection
        logoimage={portfolioData.logoimage}
        title={portfolioData.title}
        description={portfolioData.description}
        buttontext={portfolioData.buttontext}
        buttonlink={portfolioData.buttonlink}
        image={portfolioData.image}
        equalColumns={true}
      />

      <Overviewsection
        image={overviewData.image}
        title={overviewData.title}
        description={overviewData.description}
        buttontext={overviewData.buttontext}
        buttonlink={overviewData.buttonlink}
      />
      <Technologysection
        mainTitle={technologyData.mainTitle}
        subTitle={technologyData.subTitle}
        categories={technologyData.categories}
      />
      <WebsiteFeaturesBanner
        title={WebsiteFeaturesData.title}
        description={WebsiteFeaturesData.description}
        image={WebsiteFeaturesData.image}
        imageAlt={WebsiteFeaturesData.imageAlt}
        websiteFeaturesTitle={WebsiteFeaturesData.websiteFeaturesTitle}
        websiteFeatures={WebsiteFeaturesData.websiteFeatures}
        adminPanelTitle={WebsiteFeaturesData.adminPanelTitle}
        adminFeatures={WebsiteFeaturesData.adminFeatures}
      />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default AppPortfoliosdetailsPage;
